import Type3Animation from "assets/medicine/type-3.json";
import Type4Animation from "assets/medicine/type-4.json";

export const homeData = {
  id: {
    firstSection: {
      title: `Dengan <br className="md:hidden"/> Paracetamol, <br className="md:hidden"/> Phenylephrine HCl, <br /> Chlorpeniramine <br className="md:hidden" />maleat.
      <div className="mt-10">
        <span className="text-tertiary font-bold">Flu dan Batuk <br className="md:hidden"/> reda dalam <br className="md:hidden"/> 48 jam</span> <br className="hidden lg:block" />
            secara <br className="md:hidden" /> aman dan efektif.*
      </div>
    `,
      subTitle: "Buktikan Sendiri",
    },
    secondSection: {
      benefits: {
        first: "Bekerja dengan efektif meredakan demam, sakit kepala, hidung tersumbat, dan bersin-bersin.",
        second:
          "Kandungan bahan Paracetamol yang dikombinasi dengan Phenylephrine HCl dan Chlorpheniramine Maleate bantu melegakan hidung tersumbat dan bersin-bersin yang mungkin menganggu aktivitas.",
        third: "Dirancang secara khusus mempunyai formula yang secara aman dan efektif meredakan flu dan batuk.",
      },
      funFacts: {
        first: `<span className="text-primary font-bold">7 dari 10</span> orang mengalami gejala flu dan batuk disaat musim pancaroba.`,
        second: `<span className="text-primary font-bold">25%</span> merasa flu pasti disertai batuk yang membandel`,
        third: `<span className="text-primary font-bold">8 dari 10</span> orang yang sudah mencoba, percayai produk kami sebagai solusi Flu mereka`,
      },
    },
    thirdSection: {
      title: `Procold diproduksi oleh <span className="text-primary">Kalbe Farma</span>, produsen obat ternama dan dipercaya dari generasi ke generasi sejak 49 tahun yang lalu.`,
      subTitle:
        "Procold kemasan praktis dapat dibawa kemana saja. Dosis yang tepat, membantu meredakan Flu dan Batuk dalam 48 jam secara aman dan efektif. Buktikan Sendiri.",
      imageSrc: require("assets/products/id-product.png"),
      compositionInfo: `Obat flu dengan <span className="font-bold text-primary">Paracetamol, Phenylephrine HCI, dan Chlorpheniramine Maleat (CTM)</span>, yang dilengkapi dengan <span className="font-bold text-primary">Dextromethorphan HBr</span>, redakan meredakan gejala flu dan batuk`,
    },
    fourthSection: {
      title: `Procold sudah menemani masyarakat di Indonesia selama <span className="text-primary-dark font-bold">51 tahun dan dipercaya</span> dari yang muda hingga tua untuk solusi flu dan batuk.`,
      whereToBuy: true,
    },
    medicineSection: {
      title: `Namun, obat dengan kombinasi kandungan dibawah ini dapat membantu <span className="font-bold">meredakan flu dan batuk hanya dalam 48 jam</span>`,
      subTitle: "Secara medis, dibutuhkan 1-2 minggu untuk efektif meredakan gejala flu dan batuk",
      animationData: Type4Animation,
    },
    articleSection: {
      title: `Artikel untuk Memahami <span className="text-linear-1 font-bold">Flu dan Batuk</span>`,
      articles: [
        {
          imageURL: require("assets/articles/01.png"),
          title: "Ketahui Aturan Minum Paracetamol yang Tepat untuk Atasi Flu dan Batuk",
          subTitle:
            "Paracetamol kerap dikonsumsi sebagai cara cepat untuk mengatasi flu dan batuk. Namun, untuk memaksimalkan kinerjanya, ada aturan minum paracetamol yang penting untuk diketahui dan diterapkan.",
          to: "/article/1",
        },
        {
          imageURL: require("assets/articles/02.png"),
          title: "Manfaat Paracetamol untuk Atasi Flu dan Batuk",
          subTitle:
            "Manfaat paracetamol untuk meredakan gejala flu dan batuk tidak perlu diragukan lagi. Obat golongan pereda nyeri ini efektif untuk meringankan gejala flu, seperti demam, sakit kepala, sekaligus nyeri otot, selama dikonsumsi dengan dosis dan aturan yang tepat.",
          to: "/article/2",
        },
        {
          imageURL: require("assets/articles/03.png"),
          title: "7 Cara Mengatasi Flu di Rumah yang Cepat dan Ampuh",
          subTitle:
            "Beragam cara mengatasi flu dapat Anda lakukan dengan mudah di rumah. Cara ini diketahui ampuh untuk meredakan berbagai gejala flu dan keluhan lain yang menyertai. Dengan begitu, flu akan lebih cepat hilang dan Anda pun bisa kembali beraktivitas dengan nyaman.",
          to: "/article/3",
        },
        {
          imageURL: require("assets/articles/04.png"),
          title: "Flu dan Batuk Selama Musim Pancaroba, Kenali Cara Mengatasinya!",
          subTitle:
            "Musim pancaroba identik dengan perubahan cuaca yang sulit diprediksi dan bikin sebagian orang lebih mudah terkena flu dan batuk. Kalau dibiarkan tanpa pengobatan, flu dan batuk selama musim pancaroba ini bisa mengganggu aktivitas, lho. Jadi, penting untuk tahu cara mengatasinya.",
          to: "/article/4",
        },
        {
          imageURL: require("assets/articles/05.png"),
          title: "Kenali Kandungan Obat Flu dan Batuk yang Ampuh Atasi Keluhan",
          subTitle:
            "Kandungan obat flu dan batuk biasanya terdiri dari kombinasi obat dengan cara kerja yang berbeda-beda. Kombinasi berbagai kandungan tersebut ampuh dalam meredakan gejala flu, seperti hidung tersumbat, bersin-bersin, tenggorokan gatal, dan demam.",
          to: "/article/5",
        },
      ],
    },
    footer: {
      instagramUrl: "https://www.instagram.com/procold/",
      facebookUrl: "https://www.facebook.com/procoldID",
    },
  },
  kh: {
    firstSection: {
      title: `Trusted Cold and <br className="md:hidden"/> Cough medicine <br className="md:hidden"/> for more than <br /> 20 years.
        <div className="mt-10">
          <span className="text-tertiary font-bold">Cold and Cough <br className="md:hidden"/> subsides in 48 <br className="md:hidden"/> hours</span> safely and <br className="md:hidden"/> effectively.*
        </div>`,
    },
    secondSection: {
      benefits: {
        first: "Effectively relieves fever, headache, stuffy nose, and sneezing.",
        second:
          "Paracetamol combined with Phenylephrine HCl and Chlorpheniramine Maleate helps relieve nasal congestion and sneezing that may interfere with activities.",
        third: "Specifically designed to have a formula that safely and effectively relieves colds and coughs.",
      },
      funFacts: {
        first: `<span className="text-primary font-bold">8 out of 10 people</span> consumers experienced Cold & Cough in a year`,
        second: `<span className="text-primary font-bold">8 out of 10 people</span> consumers that have tried Procold believe Procold to be one of their medicine to cure their Flu problem in the past one year`,
        third: `<span className="text-primary font-bold">8 out of 10</span> consumers that have tried Procold in the past one year recommend Procold to their friends and relatives to cure their Flu problem`,
      },
    },
    thirdSection: {
      title: `For more than 20 years, every household in Cambodia has relied on <span className="text-primary">Procold</span> as the trusted, reliable brand and medicine for colds, flu, and catarrh.`,
      subTitle:
        "Procold suitable packaging can be taken anywhere. The correct dose helps relieve cold and cough in 48 hours safely and effectively. Prove It Yourself.",
      imageSrc: require("assets/products/kh-product.png"),
      imgClassname: "lg:!w-[800px]",
      compositionInfo: `Cold medicine containing <span className="font-bold text-primary">Paracetamol, Phenylephrine HCI, dan Chlorpheniramine Maleate</span> provides fast relief from cold symptoms`,
    },
    medicineSection: {
      title: `An effective combination of medicinal ingredients to relieve colds contains <span className="font-bold">Paracetamol, Phenylephrine HCI, and Chlorpheniramine maleate</span>`,
      subTitle: "The right and effective treatment are critical to treating Cold and Cough within 48 hours",
      animationData: Type3Animation,
      isType3: true,
    },
    articleSection: {
      title: `More about <span className="text-linear-1 font-bold">Cold and Cough</span>`,
      articles: [
        {
          imageURL: require("assets/articles/01.png"),
          title: "Know the Right Paracetamol Drinking Rules to Overcome Flu and Coughs.",
          subTitle:
            "Paracetamol is often taken as a quick way to treat colds and coughs. However, to maximize its performance, there are important rules for taking Paracetamol to know and apply.",
          to: "/article/1",
        },
        {
          imageURL: require("assets/articles/02.png"),
          title: "Benefits of Paracetamol to Overcome Colds and Coughs.",
          subTitle: "The benefits of Paracetamol to relieve flu and cough symptoms do not need to be doubted.",
          to: "/article/2",
        },
        // {
        //   imageURL: require("assets/articles/03.png"),
        //   title: "7 Cara Mengatasi Flu di Rumah yang Cepat dan Ampuh",
        //   subTitle:
        //     "Beragam cara mengatasi flu dapat Anda lakukan dengan mudah di rumah. Cara ini diketahui ampuh untuk meredakan berbagai gejala flu dan keluhan lain yang menyertai. Dengan begitu, flu akan lebih cepat hilang dan Anda pun bisa kembali beraktivitas dengan nyaman.",
        //   to: "/article/3",
        // },
        {
          imageURL: require("assets/articles/04.png"),
          title: "Flu and Cough During the Transitional Season, Know How to Handle It Here",
          subTitle:
            "The transitional season is synonymous with unpredictable weather changes, making some people susceptible to colds and coughs. If left untreated, fu and cough during this transitional season can disrupt your activities. So, it's essential to know how to deal with it.",
          to: "/article/4",
        },
        {
          imageURL: require("assets/articles/05.png"),
          title: "Recognize the Content of Cold and Cough Medicine that is Powerful to Overcome Complaints",
          subTitle:
            "The ingredients of cold and cough medicines usually consist of a combination of drugs with different ways of working. Combining various ingredients effectively relieves flu symptoms, such as nasal congestion, sneezing, scratchy throat, and fever.",
          to: "/article/5",
        },
      ],
    },
    footer: {
      instagramUrl: "https://www.instagram.com/procold_cambodia/",
      facebookUrl: "https://www.facebook.com/Procoldchabchea",
    },
  },
  ng: {
    firstSection: {
      title: `Procold is the <br className="md:hidden"/> number one brand <br className="md:hidden"/> for Cold and <br className="md:hidden"/> Catarrh in Nigeria.
      <div className="mt-10">
        <span className="text-tertiary font-bold">Cold and Cough <br className="md:hidden"/> subsides in 48 <br className="md:hidden"/> hours</span> safely and <br className="md:hidden"/> effectively.*
      </div>
      <div className="mt-10">My Sure Choice</div>`,
    },
    secondSection: {
      benefits: {
        first: "Effectively relieves fever, headache, stuffy nose, and sneezing.",
        second:
          "Paracetamol combined with Phenylephrine HCl and Chlorpheniramine Maleate helps relieve nasal congestion and sneezing that may interfere with activities.",
        third: "Specifically designed to have a formula that safely and effectively relieves colds and coughs.",
      },
      funFacts: {
        first: `<span className="text-primary font-bold">9 out of 10 people</span> consumers that have tried Procold believe Procold to be one of their medicine to cure their Flu problem in the past one year.`,
        second: `<span className="text-primary font-bold">8 out of 10</span> consumers perceived Procold is effective in treating Cold.`,
        third: `<span className="text-primary font-bold">7 out of 10</span> consumers consider to choose Procold as their first choice for treating Flu.`,
      },
    },
    thirdSection: {
      title: `For more than 35 years, every household in Nigeria has relied on <span className="text-primary">Procold</span> as the trusted, reliable brand and medicine for colds, flu, and catarrh.`,
      subTitle:
        "Procold suitable packaging can be taken anywhere. The correct dose helps relieve cold and cough in 48 hours safely and effectively. Prove It Yourself.",
      imageSrc: require("assets/products/ng-product-2.png"),
      imgClassname: "lg:!w-[800px]",
      secondaryImgSrc: require("assets/products/ng-product.png"),
      secondaryImgClassname: "!w-[193px] lg:!w-[350px]",
      compositionInfo: `Cold medicine containing <span className="font-bold text-primary">Paracetamol, Phenylephrine HCI, dan Chlorpheniramine Maleate</span> provides fast relief from cold symptoms`,
    },
    fourthSection: {
      title: `
        <p className="italic mb-4 lg:mb-8">The endorsement by the Pharmaceutical Society of Nigeria (PSN) is a testament to what the brand is known for. As the number one brand for Cold and Catarrh in Nigeria, this collaboration becomes another milestone for the commitment to always provide the best product to the country.</p>
        <p>Procold and the Pharmaceutical Society of Nigeria (PSN) collaborate through a formal MoU to educate Nigerians on the safe use of authentic medicine as part of Procold's #Originalmovement campaign, emphasizing their commitment to providing trusted healthcare solutions.</p>`,
      showLogo: true,
      whereToBuy: false,
    },
    medicineSection: {
      title: `An effective combination of medicinal ingredients to relieve colds contains <span className="font-bold">Paracetamol, Phenylephrine HCI, and Chlorpheniramine maleate</span>`,
      subTitle: "The right and effective treatment are critical to treating Cold and Cough within 48 hours",
      animationData: Type3Animation,
      isType3: true,
    },
    articleSection: {
      title: `More about <span className="text-linear-1 font-bold">Cold and Cough</span>`,
      articles: [
        {
          imageURL: require("assets/articles/01.png"),
          title: "Know the Right Paracetamol Drinking Rules to Overcome Flu and Coughs.",
          subTitle:
            "Paracetamol is often taken as a quick way to treat colds and coughs. However, to maximize its performance, there are important rules for taking Paracetamol to know and apply.",
          to: "/article/1",
        },
        {
          imageURL: require("assets/articles/02.png"),
          title: "Benefits of Paracetamol to Overcome Colds and Coughs.",
          subTitle: "The benefits of Paracetamol to relieve flu and cough symptoms do not need to be doubted.",
          to: "/article/2",
        },
        // {
        //   imageURL: require("assets/articles/03.png"),
        //   title: "7 Cara Mengatasi Flu di Rumah yang Cepat dan Ampuh",
        //   subTitle:
        //     "Beragam cara mengatasi flu dapat Anda lakukan dengan mudah di rumah. Cara ini diketahui ampuh untuk meredakan berbagai gejala flu dan keluhan lain yang menyertai. Dengan begitu, flu akan lebih cepat hilang dan Anda pun bisa kembali beraktivitas dengan nyaman.",
        //   to: "/article/3",
        // },
        {
          imageURL: require("assets/articles/04.png"),
          title: "Flu and Cough During the Transitional Season, Know How to Handle It Here",
          subTitle:
            "The transitional season is synonymous with unpredictable weather changes, making some people susceptible to colds and coughs. If left untreated, fu and cough during this transitional season can disrupt your activities. So, it's essential to know how to deal with it.",
          to: "/article/4",
        },
        {
          imageURL: require("assets/articles/05.png"),
          title: "Recognize the Content of Cold and Cough Medicine that is Powerful to Overcome Complaints",
          subTitle:
            "The ingredients of cold and cough medicines usually consist of a combination of drugs with different ways of working. Combining various ingredients effectively relieves flu symptoms, such as nasal congestion, sneezing, scratchy throat, and fever.",
          to: "/article/5",
        },
      ],
    },
    footer: {
      instagramUrl: "https://www.instagram.com/procold_naija/",
      facebookUrl: "https://www.facebook.com/234Procoldng",
    },
  },
};
